// FR
export const hotelCalendarHc = {
  toolbar: {
    bulkEdit: "Édition groupée",
    cfgTitle: "Paramètres du calendrier",
    syncSection: "Synchronisation",
    resyncOta: `Resynchroniser avec l'OTA`,
    resyncOtaSub: "Renvoie la disponibilité et les tarifs au canal.",
  },
  mode: {
    calendar: "Calendrier",
    rates: "Tarifs",
  },
  search: {
    placeholder: "Rechercher un client ou un code…",
    clear: "Effacer",
    go: "Rechercher",
    resultsHint: "{count} résultats — sélectionnez-en un :",
    combo: "Combinée · {count} ch.",
  },
  header: {
    occupancy: "Occupation {pct} %",
  },
  type: {
    roomsAbbr: "ch.",
    configTitle: `Paramètres du type (OTA et règles d'arrivée/départ)`,
    otaConnected: "OTA connectée",
    subscribeToConnect: "Abonnez-vous pour connecter des OTA",
  },
  rtCell: {
    editTooltip: "Cliquez pour modifier la disponibilité, le prix, la durée minimale et la fermeture",
    overbookRisk: "Risque de surréservation",
    closedTag: "Fermé",
  },
  rules: {
    sameDayCutoff: "Arrêt des ventes le jour même à {time}",
  },
  organizeRow: {
    title: "À organiser",
    unplacedCount: "{count} réservation non affectée | {count} réservations non affectées",
    autoTooltip: `Réorganise automatiquement les réservations entre les chambres pour qu'elles tiennent toutes`,
    organizing: "Organisation…",
    organize: "Organiser",
  },
  footer: {
    available: "Disponible",
    unavailable: "Indisponible",
    closed: "Fermé",
    overbookRisk: "Risque de surréservation",
    realtime: "Les valeurs sont mises à jour en temps réel",
    timezone: "Fuseau horaire : {tz}",
  },
  dayEdit: {
    oneDay: "un jour",
    open: "Ouvert",
    closed: "Fermé",
    priceLabel: "Prix · tarif standard",
    minStayLabel: "Séjour minimum (nuits)",
    forSaleLabel: "Chambres en vente",
    forSaleHint: "plafond · max {max}",
    applyMultiple: "Appliquer à plusieurs dates ?",
    cancel: "Annuler",
    saving: "Enregistrement…",
    save: "Enregistrer",
  },
  roomMenu: {
    create: "Créer une réservation",
    createSub: "Réservation sur la plage sélectionnée",
    block: "Bloquer 1 chambre",
    blockSub: "Ferme cette chambre sur la plage",
    unblock: "Retirer le blocage",
    unblockSub: "Rouvre cette chambre sur la plage",
    oos: "Hors service",
    oosSub: "Maintenance de cette chambre",
  },
  closureMenu: {
    turnoverTitle: "Défini par le temps de préparation",
    turnoverSub: "Il se déplace avec les dates de la réservation et disparaît si elle est annulée.",
    changeRule: "Modifier la règle",
    changeRuleSub: "Ajuster ou désactiver le temps de préparation",
    editReason: "Modifier le motif",
    editReasonSub: "Modifier le motif du blocage",
    changeRoom: "Changer de chambre",
    changeRoomSub: "Déplacer vers une autre chambre du type",
    unblock: "Retirer le blocage",
    unblockSub: `Rouvre et libère l'espace`,
    moveTo: "Déplacer vers…",
    noOtherRooms: `Il n'y a pas d'autres chambres dans ce type.`,
    barTooltip: "Blocage : {reason} — cliquez pour modifier ou retirer",
  },
  typeConfig: {
    seasons: "Price seasons",
    seasonsSub: "Raise or lower prices by date",
    manageOta: "Gérer la connexion OTA",
    connectOta: "Connecter une OTA",
    otaSub: `Synchronise l'hébergement avec les OTA`,
    arrivalRules: `Règles d'arrivée et de départ`,
    arrivalRulesSub: "Jours de check-in / check-out autorisés",
  },
  // La habitación se ocupó unas HORAS, no una noche: en el calendario por
  // días se lee como un bloqueo con su motivo.
  hourly: {
    sold: "Vendue à l'heure",
    soldOne: "Vendue à l'heure · {range}",
    soldMany: "Vendue à l'heure · {count} séjours",
  },
  tooltip: {
    past: "Passée",
    unassignedHtml: "<strong>Aucune chambre attribuée.</strong> La disponibilité est répartie entre les chambres. Utilisez <strong>Organiser</strong> pour la réorganiser automatiquement, ou cliquez et attribuez-lui une chambre.",
    nights: "{count} nuit | {count} nuits",
    guests: "{count} client | {count} clients",
  },
  channels: {
    direct: "Directe",
  },
  syncModal: {
    title: `Synchroniser avec l'OTA`,
    message: `La disponibilité et le séjour maximum de ce calendrier seront recalculés et renvoyés à l'OTA.`,
    confirm: "Oui, synchroniser",
    cancel: "Annuler",
  },
  syncTooltip: {
    can: `Recalcule et renvoie à l'OTA la disponibilité et le séjour maximum (évite la surréservation).`,
    cannot: `Connectez l'hébergement à un canal pour pouvoir synchroniser.`,
  },
  block: {
    editTitle: "Modifier le motif",
    createTitle: "Bloquer la chambre",
    reasonLabel: "Motif du blocage",
    reasonHint: "(il sera affiché sur le calendrier)",
    placeholder: "Ex : Maintenance, usage du propriétaire…",
    cancel: "Annuler",
    saving: "Enregistrement…",
    saveReason: "Enregistrer le motif",
    blockBtn: "Bloquer",
    defaultReason: "Bloqué",
    thisRoom: "cette chambre",
    editReasonMsg: `Modifier le motif du blocage de "{room}" ({count} nuit). | Modifier le motif du blocage de "{room}" ({count} nuits).`,
    createMsg: `"{room}" ({unit}) sera fermée pendant {count} nuit. Il ne sera pas possible d'y réserver à ces dates ; les autres chambres du type restent disponibles. | "{room}" ({unit}) sera fermée pendant {count} nuits. Il ne sera pas possible d'y réserver à ces dates ; les autres chambres du type restent disponibles.`,
    presets: {
      maintenance: "Maintenance",
      ownerUse: "Usage du propriétaire",
      renovation: "Rénovation",
      deepCleaning: "Nettoyage en profondeur",
      externalReserved: "Réservé (externe)",
    },
  },
  organizeModal: {
    title: "Organiser automatiquement",
    bodyHtml: `Nous chercherons la meilleure répartition et <strong>réorganiserons les réservations entre les chambres</strong> de ce type afin que <strong>{count} réservation non affectée tienne</strong> d'affilée. | Nous chercherons la meilleure répartition et <strong>réorganiserons les réservations entre les chambres</strong> de ce type afin que <strong>{count} réservations non affectées tiennent</strong> d'affilée.`,
    point1Html: "Seule la <strong>chambre physique</strong> attribuée change.",
    point2Html: "Les <strong>dates, prix et clients</strong> ne sont pas modifiés.",
    point3: `Si l'une ne tient pas d'affilée, nous vous prévenons.`,
    cancel: "Annuler",
    organizing: "Organisation…",
    confirm: "Oui, organiser",
  },
  empty: {
    noHotelTitle: "Aucune annonce de type hôtel",
    noHotelSubHtml: "Créez une annonce de type <strong>Hôtel</strong> ou <strong>Camping</strong> pour commencer à gérer la disponibilité par chambre.",
    noHotelBtn: "Aller aux annonces",
    noRoomsTitle: `{name} n'a pas de chambres`,
    noRoomsSub: `Cette annonce n'a pas encore de chambres enregistrées. Ajoutez des chambres dans les paramètres de l'annonce pour voir le calendrier.`,
    noRoomsBtn: `Configurer l'annonce`,
  },
  mock: {
    today: `Aujourd'hui`,
    month: "MAI 2026",
    searchPlaceholder: "Rechercher par nom ou code…",
    searchBtn: "Rechercher",
    createBtn: "Créer une réservation",
    na: "N/D",
    forSaleLabel: "Disp. en vente",
    suiteDeluxe: "Suite Deluxe",
    standardRoom: "Chambre Standard",
    roomsCount2: "(2 ch.)",
    roomsCount3: "(3 ch.)",
    no: "N°",
    room101: "Chambre 101",
    room102: "Chambre 102",
    room201: "Chambre 201",
    room202: "Chambre 202",
    room203: "Chambre 203",
    d1: "lun. 1",
    d2: "mar. 2",
    d3: "mer. 3",
    d4: "jeu. 4",
    d5: "ven. 5",
    d6: "sam. 6",
    d7: "dim. 7",
    d8: "lun. 8",
    d9: "mar. 9",
    d10: "mer. 10",
    d11: "jeu. 11",
    d12: "ven. 12",
  },
  ops: {
    closingDay: "Fermeture du jour…",
    openingDay: "Ouverture du jour…",
    saving: "Enregistrement…",
    movingBlock: "Déplacement du blocage…",
    swappingBlockReservation: "Échange du blocage et de la réservation…",
    swappingReservationBlock: "Échange de la réservation et du blocage…",
    swappingRooms: "Échange des chambres…",
    changingRoom: "Changement de chambre…",
    organizingRooms: "Organisation des chambres…",
    syncingWithOta: `Synchronisation du calendrier avec l'OTA…`,
    processing: "Traitement…",
    settingMaintenance: "Mise en maintenance…",
    clearingMaintenance: "Retrait de la maintenance…",
    updatingAvailability: "Mise à jour de la disponibilité…",
    updatingReason: "Mise à jour du motif…",
    closingRoom: "Fermeture de la chambre…",
    removingBlock: "Retrait du blocage…",
  },
  toasts: {
    dayClosed: "Jour fermé",
    dayOpened: "Jour ouvert",
    availabilityUpdateErr: "Impossible de mettre à jour la disponibilité",
    dayUpdated: "Jour mis à jour",
    daySaveErr: `Impossible d'enregistrer le jour`,
    moveTargetMultipleReservations: "La destination comporte plusieurs réservations dans cette plage ; déplacez-les manuellement.",
    roomRejectsBlock: `Cette chambre n'accepte pas le blocage sur cette plage`,
    blockMoved: "Blocage déplacé de chambre",
    blockMoveErr: "Impossible de déplacer le blocage",
    swapStartErr: `Impossible de démarrer l'échange`,
    reservationNoFitSwap: `La réservation ne tient pas dans l'autre chambre sur toute sa plage ; l'échange a échoué.`,
    reservationMoveErr: "Impossible de déplacer la réservation",
    swapCompleteErr: `Impossible de terminer l'échange (il a été annulé)`,
    blockReservationSwapped: "Blocage et réservation échangés",
    swapErr: `Impossible d'effectuer l'échange`,
    rangeHasOccupiedOrClosed: "La plage inclut des nuits occupées ou fermées dans cette chambre.",
    organizeErr: `Impossible d'organiser automatiquement.`,
    organizeNothing: `Il n'y avait rien à réorganiser.`,
    organizePartial: `{done} réservation(s) ont été organisées, mais {unplaced} ne tiennent pas d'affilée dans aucune combinaison.`,
    organizeDoneAssigned: "Calendrier organisé : {assigned} affectée(s)",
    organizeDoneMoved: ", {moved} déplacée(s) de chambre",
    swapGroupDone: "Échange groupé terminé : {groupCount} ⇄ {swappedCount} réservations.",
    roomsSwappedWith: "Chambres échangées avec {names}.",
    noPropertyToSync: "Aucun hébergement à synchroniser.",
    calendarResynced: `Calendrier recalculé et synchronisé avec l'OTA.`,
    syncErr: `Impossible de synchroniser le calendrier avec l'OTA.`,
    genericError: "Erreur",
    reservationNoFitSwapStrict: `Échange impossible : la réservation n'est pas libre sur toute sa plage.`,
    reservationBlockSwapped: "Réservation et blocage échangés",
    roomCloseErr: "Impossible de fermer la chambre",
    reasonUpdated: "Motif mis à jour",
    roomClosedInRange: "Chambre fermée sur la plage",
    blockRemoved: "Blocage retiré",
    blockRemoveErr: "Impossible de retirer le blocage",
    searchMinChars: "Saisissez au moins 2 caractères pour rechercher",
    searchNoResults: "Aucune réservation trouvée pour cette recherche",
    searchErr: "Erreur lors de la recherche de réservations",
  },
  summary: {
    stateAvailable: "Disponible",
    stateClosed: "Fermé",
    stateNoDisp: "Indisp.",
  },
};
